import {FormItemDataModel} from '../../../models/forms/data/form-item-data.model';

export class NotesFromFormModel {
  parentItem: FormItemDataModel;
  children: FormItemDataModel[] = [];
}
